export default "__VITE_ASSET__DqUiO$xQ__"